import { render, staticRenderFns } from "./check-list.vue?vue&type=template&id=379ed23f&scoped=true"
import script from "./check-list.vue?vue&type=script&lang=js"
export * from "./check-list.vue?vue&type=script&lang=js"
import style0 from "./check-list.vue?vue&type=style&index=0&id=379ed23f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379ed23f",
  null
  
)

export default component.exports